/*
  Sepet: adet/kaldır → /cart/change.js (sections ile bölüm + sepet ikonu yeniden çizilir, toplam anında güncellenir).
  Onay modalı: product-form.js sepete eklemeden sonra renderContents() çağırır; sayfa değişmez. Vanilla JS.
*/

if (!customElements.get('alv-cart')) {
  class AlvCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.querySelectorAll('[data-alv-row]').forEach((row) => {
        const key = row.dataset.key;
        const value = row.querySelector('[data-alv-qty-value]');
        row.querySelectorAll('[data-alv-qty]').forEach((btn) =>
          btn.addEventListener('click', () => {
            const next = Math.max(0, Number(value.textContent) + Number(btn.dataset.alvQty));
            this.change(key, next);
          })
        );
        const remove = row.querySelector('[data-alv-remove]');
        if (remove) remove.addEventListener('click', () => this.change(key, 0));
      });
    }

    change(key, quantity) {
      if (this.getAttribute('aria-busy') === 'true') return;
      this.setAttribute('aria-busy', 'true');
      fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity,
          sections: `${this.sectionId},cart-icon-bubble`,
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json())
        .then((state) => {
          const sections = state.sections || {};
          AlvCart.replaceSection(this.sectionId, sections[this.sectionId]);
          AlvCart.replaceBubble(sections['cart-icon-bubble']);
        })
        .catch(() => {
          this.removeAttribute('aria-busy');
        });
    }

    static replaceSection(id, html) {
      if (!html) return;
      const wrapper = document.getElementById(`shopify-section-${id}`);
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (wrapper && fresh) wrapper.innerHTML = fresh.innerHTML;
    }

    static replaceBubble(html) {
      if (!html) return;
      const bubble = document.getElementById('cart-icon-bubble');
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }
  }

  customElements.define('alv-cart', AlvCart);
}

if (!customElements.get('alv-cart-modal')) {
  class AlvCartModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.alv-cart-modal__dialog');
      this.querySelectorAll('[data-alv-modal-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
        }
      });
    }

    /* product-form.js sözleşmesi */
    getSectionsToRender() {
      return [{ id: 'cart-icon-bubble' }];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    renderContents(parsedState) {
      const sections = parsedState.sections || {};
      const html = sections['cart-icon-bubble'];
      if (html) {
        const bubble = document.getElementById('cart-icon-bubble');
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
      }
      this.open();
    }

    open() {
      clearTimeout(this.hideTimer);
      this.hidden = false;
      void this.offsetWidth; // reflow — 200ms opacity + 8px translateY geçişi oynasın
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      trapFocus(this.dialog, this.querySelector('.alv-cart-modal__actions .button'));
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.activeElement);
      this.hideTimer = setTimeout(() => {
        if (!this.hasAttribute('open')) this.hidden = true;
      }, 220); // --alv-t-base (200ms) + pay
    }
  }

  customElements.define('alv-cart-modal', AlvCartModal);
}
